import { MoreVert } from "@mui/icons-material";
import { Checkbox, IconButton, Menu, MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";

interface MenuOption {
  label: string;
  value: string | number;
  disabled?: boolean;
}

interface DotsMenuProps {
  options: MenuOption[];
  onClose?: () => void;
  icon?: React.ReactNode;
  onChange?: (selected: (string | number)[]) => void;
  value?: number | number[] | string[] | string;
  showCheckbox?: boolean;
  disabled?: boolean;
}

const DotsMenu: React.FC<DotsMenuProps> = ({
  options,
  onClose,
  icon,
  value,
  onChange,
  showCheckbox = false,
  disabled = false
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [selected, setSelected] = useState<(string | number)[]>([]);

  useEffect(() => {
    if (Array.isArray(value)) {
      setSelected(value);
    } else {
      setSelected((value ? [value] : []) as string[] | number[]);
    }
  }, [value]);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    onClose?.();
  };

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLElement>,
    option: MenuOption
  ) => {
    event.preventDefault();
    event.stopPropagation();
    if (disabled) {
      return;
    }


    if (selected.find((o) => o === option.value)) {
      setSelected(
        (prev) => prev.filter((o) => o !== option.value) as string[] | number[]
      );
      onChange?.(selected.filter((o) => o !== option.value) as typeof selected);
    } else {
      setSelected([...selected, option.value] as string[] | number[]);
      onChange?.([...selected, option.value] as typeof selected);
    }
  };

  return (
    <>
      <IconButton onClick={handleClick}>{icon || <MoreVert />}</IconButton>
      <Menu
      
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {options.map((option, index) => (
          <MenuItem
            key={index}
            disabled={disabled || option.disabled}
            onClick={(event) => handleMenuItemClick(event, option)}
            sx={{
              textTransform: "capitalize",
              color: "#171D19",
              fontWeight: "medium",
              fontSize: 12,
            }}
          >
            {showCheckbox && (
              <Checkbox
                sx={{ paddingX: 0.5, paddingY: 0 }}
                checked={
                  selected.find((o) => o === option.value) ? true : false
                }
                size="small"
              />
            )}
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default DotsMenu;
